/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import {ActionRequestStateBeforeService} from "./ActionRequestStateBeforeService";

class ActionRequestStateBeforeServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ActionRequestStateBeforeService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { ActionRequestStateBeforeServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestStateBeforeServiceProvider.js